import React from "react";
import HeaderThree from "../common/header/HeaderThree";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import FeatureTwo from "../components/features/FeatureTwo";
import ProjectOne from "../components/project/ProjectOne";
import FooterOne from "../common/footer/FooterOne";
import WhyChooseOne from "../components/why-choose-us/WhyChooseOne";
import ServiceOne from "../components/services/ServiceOne";
import { ButtonGetQuote } from "../components/ButtonGetQuote";

const ServicesPage = () => {
  return (
    <>
      <HeaderThree />
      <Breadcrumb heading="Services Us" currentPage="Services Us" />
      <WhyChooseOne />
      <FeatureTwo />
      <ProjectOne />
      <div className="my-40" />
      <ServiceOne />
      <FooterOne />
      <ButtonGetQuote />
    </>
  );
};

export default ServicesPage;
